import React from "react";
import { KTIcon } from "../../_metronic/helpers";
import icons from "../../_metronic/helpers/icons-config/icons";
                  
export function Icons() {
    const convert = (data:any) => Object.entries(data).map(([key, value]) => ({ [key]: value }));
    let iconArray=convert(icons);
    return (<>
        {
        
        iconArray.map((icon, index) => {
            let iconName = Object.keys(icon)[0];
            let iconType = Object.values(icon)[0];
            return (<div><KTIcon iconName={iconName}  className='fs-6x' />  {iconName}</div>);
        })
    }
     
    </>);
    
}